import { ThemeProvider } from '@material-ui/core';
import { handleApiError, setBaseUrl } from '@services/http';
import { AuthProvider, AuthService } from '@swyft/auth';
import { BaseMuiTheme } from '@theme';
import { QueryClient, QueryClientProvider } from 'react-query';
import { runtimeConfig } from './config';
import { AppRoutes } from './routes';

setBaseUrl(runtimeConfig.api.baseUrl);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
      retry: false
    }
  }
});

const authService = new AuthService({
  authority: runtimeConfig.auth.authority,
  clientId: runtimeConfig.auth.clientId,
  basePath: '',
  handleRedirectCallbackState: window.location.replace
});

function App(): JSX.Element {
  return (
    <ThemeProvider theme={BaseMuiTheme}>
      <AuthProvider authService={authService} handleApiError={handleApiError}>
        <QueryClientProvider client={queryClient}>
          <AppRoutes />
        </QueryClientProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
